import React, { Fragment } from 'react'
import PlaySelectGrid from './PlaySelectionGrid'
import ClosePlay from './ClosePlay'
import YardsDowns from './YardsDowns'
import StatsUpdate from './StatsUpdate'
import Score from './Score'
import Header from './Header'
import Possession from './Possession'
import Submit from './Submit'
import State from './State'
import { Grid } from 'semantic-ui-react'
import { Route } from 'react-router-dom'
import {
  CONTROLLER as CONTROLLER_ROUTE,
  PLAY_SELECT as PLAY_SELECT_ROUTE,
  STATS_UPDATE as STATS_UPDATE_ROUTE,
  POSSESSION as POSSESSION_ROUTE,
  PENALTY as PENALTY_ROUTE,
  SCORE as SCORE_ROUTE
} from './routes'

const Controller = () => {
  return (
    <Route
      path={CONTROLLER_ROUTE}
      render={routeProps => (
        <Grid
          centered
          style={{
            width: '100%',
            maxWidth: '726px',
            margin: 'auto',
            padding: 0
          }}
        >
          <State {...routeProps}>
            <Route path={CONTROLLER_ROUTE} component={Header} />
            <Route exact path={CONTROLLER_ROUTE} component={ClosePlay} />
            <Route exact path={PLAY_SELECT_ROUTE} component={PlaySelectGrid} />
            <Route exact path={STATS_UPDATE_ROUTE} component={StatsUpdate} />
            <Route exact path={SCORE_ROUTE} component={Score} />
            <Route exact path={POSSESSION_ROUTE} component={Possession} />
            <Route
              exact
              path={PENALTY_ROUTE}
              render={() => (
                <Fragment>
                  <YardsDowns />
                  <Submit />
                </Fragment>
              )}
            />
          </State>
        </Grid>
      )}
    />
  )
}

export default Controller



// WEBPACK FOOTER //
// ./src/components/Controller/index.jsx